export default "__VITE_ASSET__RRKyI9Or__"